import { Box, Divider, Grid, Paper, Typography } from '@mui/material'

import ToothGraphic4 from '@/assets/images/Tooth-graphic-4.svg'
import PieChart from '@/components/PieChart'
import { isNullorEmpty } from '@/utils'

const DentinPDF = ({
  recipe,
  dentinCervicalIndex,
  dentinMiddleIndex,
  dentinIncisalIndex,
}) => {
  return (
    <Box
      sx={{
        backgroundColor: '#FFF',
        p: 3,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        color: 'black',
      }}
      id="download-page-2"
    >
      {recipe.dentinlayer_advice && (
        <>
          <Grid container spacing={2} alignItems="stretch">
            {/* Left Section */}
            <Grid item xs={4}>
              <Paper
                elevation={0}
                sx={{ backgroundColor: '#FFF', color: '#000', p: 2 }}
              >
                <img
                  src={ToothGraphic4}
                  alt="Toothimage"
                  style={{ width: '233px', height: '330px' }}
                />
              </Paper>
            </Grid>

            {/* Right Section */}
            <Grid item xs={8} container alignItems="center">
              <Box sx={{ width: '100%' }}>
                {/* Dentin Brand */}
                <Box display="flex" alignItems="center" m={2}>
                  <Typography
                    variant="h5"
                    component="div"
                    sx={{ marginRight: 2 }}
                  >
                    Dentin:
                  </Typography>
                  {isNullorEmpty(recipe, 'provided_input', 'brand') && (
                    <Box
                      sx={{
                        backgroundColor: '#F44336',
                        borderRadius: '16px',
                        p: 1,
                      }}
                    >
                      {recipe.provided_input.brand}
                    </Box>
                  )}
                </Box>

                {/* Dentin Cervical */}
                {recipe.dentinlayer_advice.dentinrecipes_cervical && (
                  <>
                    <Divider />
                    <Box my={3}>
                      <Typography>Cervical</Typography>
                      <Grid container spacing={2}>
                        {[1, 2].map((layer) => (
                          <Grid item xs={4} key={layer}>
                            {recipe.dentinlayer_advice.dentinrecipes_cervical[
                              `recipe_layer${layer}`
                            ]?.[dentinCervicalIndex] && (
                              <>
                                {isNullorEmpty(
                                  recipe,
                                  'dentinlayer_advice',
                                  'dentinrecipes_cervical',
                                  `recipe_layer${layer}`,
                                  `${dentinCervicalIndex}`,
                                  'opacity_category',
                                ) && (
                                  <Typography
                                    textAlign="center"
                                    sx={{
                                      textTransform: 'capitalize',
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    {
                                      recipe.dentinlayer_advice
                                        .dentinrecipes_cervical[
                                        `recipe_layer${layer}`
                                      ][dentinCervicalIndex].opacity_category
                                    }
                                  </Typography>
                                )}
                                <PieChart
                                  labels={
                                    recipe.dentinlayer_advice
                                      .dentinrecipes_cervical[
                                      `recipe_layer${layer}`
                                    ][dentinCervicalIndex].powders
                                  }
                                  values={
                                    recipe.dentinlayer_advice
                                      .dentinrecipes_cervical[
                                      `recipe_layer${layer}`
                                    ][dentinCervicalIndex].simplified_ratios
                                  }
                                />
                              </>
                            )}
                          </Grid>
                        ))}
                        <Grid
                          item
                          xs={4}
                          display="flex"
                          justifyContent="flex-end"
                          alignItems="center"
                        >
                          {dentinCervicalIndex + 1}
                        </Grid>
                      </Grid>
                    </Box>
                  </>
                )}

                {/* Dentin Middle */}
                {recipe.dentinlayer_advice.dentinrecipes_middle && (
                  <>
                    <Divider />
                    <Box my={3}>
                      <Typography>Middle</Typography>
                      <Grid container spacing={2}>
                        {[1, 2].map((layer) => (
                          <Grid item xs={4} key={layer}>
                            {recipe.dentinlayer_advice.dentinrecipes_middle[
                              `recipe_layer${layer}`
                            ]?.[dentinMiddleIndex] && (
                              <>
                                {isNullorEmpty(
                                  recipe,
                                  'dentinlayer_advice',
                                  'dentinrecipes_middle',
                                  `recipe_layer${layer}`,
                                  `${dentinMiddleIndex}`,
                                  'opacity_category',
                                ) && (
                                  <Typography
                                    textAlign="center"
                                    sx={{
                                      textTransform: 'capitalize',
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    {
                                      recipe.dentinlayer_advice
                                        .dentinrecipes_middle[
                                        `recipe_layer${layer}`
                                      ][dentinMiddleIndex].opacity_category
                                    }
                                  </Typography>
                                )}
                                <PieChart
                                  labels={
                                    recipe.dentinlayer_advice
                                      .dentinrecipes_middle[
                                      `recipe_layer${layer}`
                                    ][dentinMiddleIndex].powders
                                  }
                                  values={
                                    recipe.dentinlayer_advice
                                      .dentinrecipes_middle[
                                      `recipe_layer${layer}`
                                    ][dentinMiddleIndex].simplified_ratios
                                  }
                                />
                              </>
                            )}
                          </Grid>
                        ))}
                        <Grid
                          item
                          xs={4}
                          display="flex"
                          justifyContent="flex-end"
                          alignItems="center"
                        >
                          {dentinMiddleIndex + 1}
                        </Grid>
                      </Grid>
                    </Box>
                  </>
                )}

                {/* Dentin Incisal */}
                {recipe.dentinlayer_advice.dentinrecipes_incisal && (
                  <>
                    <Divider />
                    <Box my={3}>
                      <Typography>Incisal</Typography>
                      <Grid container spacing={2}>
                        {[1, 2].map((layer) => (
                          <Grid item xs={4} key={layer}>
                            {recipe.dentinlayer_advice.dentinrecipes_incisal[
                              `recipe_layer${layer}`
                            ]?.[dentinIncisalIndex] && (
                              <>
                                {isNullorEmpty(
                                  recipe,
                                  'dentinlayer_advice',
                                  'dentinrecipes_incisal',
                                  `recipe_layer${layer}`,
                                  `${dentinIncisalIndex}`,
                                  'opacity_category',
                                ) && (
                                  <Typography
                                    textAlign="center"
                                    sx={{
                                      textTransform: 'capitalize',
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    {
                                      recipe.dentinlayer_advice
                                        .dentinrecipes_incisal[
                                        `recipe_layer${layer}`
                                      ][dentinIncisalIndex].opacity_category
                                    }
                                  </Typography>
                                )}
                                <PieChart
                                  labels={
                                    recipe.dentinlayer_advice
                                      .dentinrecipes_incisal[
                                      `recipe_layer${layer}`
                                    ][dentinIncisalIndex].powders
                                  }
                                  values={
                                    recipe.dentinlayer_advice
                                      .dentinrecipes_incisal[
                                      `recipe_layer${layer}`
                                    ][dentinIncisalIndex].simplified_ratios
                                  }
                                />
                              </>
                            )}
                          </Grid>
                        ))}
                        <Grid
                          item
                          xs={4}
                          display="flex"
                          justifyContent="flex-end"
                          alignItems="center"
                        >
                          {dentinIncisalIndex + 1}
                        </Grid>
                      </Grid>
                    </Box>
                  </>
                )}

                <Divider />
              </Box>
            </Grid>
          </Grid>
        </>
      )}
    </Box>
  )
}

export default DentinPDF
